var _circle, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudentsCards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28,
    fill: "#FFF9DD",
    stroke: "#FFE673",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6424 36.1406C22.6875 36.1406 21.8729 36.7529 21.5703 37.6055H25.7145C25.412 36.7529 24.5973 36.1406 23.6424 36.1406Z",
    fill: "url(#paint0_linear_1351_3019)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6387 33.2109C24.0432 33.2109 24.3711 32.883 24.3711 32.4785C24.3711 32.074 24.0432 31.7461 23.6387 31.7461C23.2342 31.7461 22.9062 32.074 22.9062 32.4785C22.9062 32.883 23.2342 33.2109 23.6387 33.2109Z",
    fill: "url(#paint1_linear_1351_3019)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5566 27.3516V29.7999L29.5 31.8141L24.8651 30.6554C25.4514 31.0503 25.8379 31.72 25.8379 32.4785C25.8379 33.6901 24.8522 34.6758 23.6406 34.6758C25.6598 34.6758 27.3027 36.3187 27.3027 38.3379V39.0703H19.9785V38.3379C19.9785 36.3187 21.6214 34.6758 23.6406 34.6758C22.429 34.6758 21.4434 33.6901 21.4434 32.4785C21.4434 31.3331 22.3272 30.4006 23.4471 30.3008L21.4434 29.7999V27.366L17 27.3516V42H42V27.3516H37.5566ZM33.1621 31.7461H34.627V33.2109H33.1621V31.7461ZM30.2324 31.7461H31.6973V33.2109H30.2324V31.7461ZM37.5566 39.0703H30.2324V37.6055H37.5566V39.0703ZM37.5566 36.1406H30.2324V34.6758H37.5566V36.1406ZM37.5566 33.2109H36.0918V31.7461H37.5566V33.2109Z",
    fill: "url(#paint2_linear_1351_3019)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 25.9511L17 20.6203L29.5 17L42 20.6203L29.5 25.9511Z",
    fill: "url(#paint3_linear_1351_3019)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.498 27.5452L22.9062 24.7188V28.6567L29.498 30.3046L36.0898 28.6567V24.7188L29.498 27.5452Z",
    fill: "url(#paint4_linear_1351_3019)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5547 24.09V25.8865H39.0195V23.4619L37.5547 24.09Z",
    fill: "url(#paint5_linear_1351_3019)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1351_3019",
    x1: 22.5291,
    y1: 36.9688,
    x2: 25.6847,
    y2: 36.9667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1351_3019",
    x1: 23.2452,
    y1: 32.5743,
    x2: 24.3606,
    y2: 32.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1351_3019",
    x1: 22.7842,
    y1: 35.6336,
    x2: 41.8203,
    y2: 35.6258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1351_3019",
    x1: 22.7842,
    y1: 22.0608,
    x2: 41.8203,
    y2: 22.0481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1351_3019",
    x1: 25.9565,
    y1: 27.877,
    x2: 35.9951,
    y2: 27.8713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1351_3019",
    x1: 37.8936,
    y1: 24.8328,
    x2: 39.009,
    y2: 24.8326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentsCards);
export default __webpack_public_path__ + "static/media/Students Cards.16d81394087527ff9857d834554c4402.svg";
export { ForwardRef as ReactComponent };